import { END_POINT_AUTH_TOKEN } from "./apiEndPoints";
import ApiManager from "./apiManager";

export class AuthenticationApi {
  async login(request): Promise<string> {
    const res = await ApiManager.auth(END_POINT_AUTH_TOKEN, request);
    if (res && res.accessToken) {
      return res.accessToken;
    }

    return undefined;
  }
}

export default new AuthenticationApi();
